import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  CommonErrorMsg,
  confirmDelete,
  ErrorMsg,
  sessionUser,
  ValidateForm,
} from "../../Util/common";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { CorebaseURL, corefetch, corepost } from "../../Util/axios_core_helper";
import { KendoDropdown } from "../../Kendo/kendo_dropdown";
import { generateGuid } from "../../Kendo/kendo_common";

export const Contact = () => {
  const [editVisible, setEditVisible] = useState(false);
  const [error, setError] = useState({});
  const [refreshflag, setrefreshflag] = useState(0);
  const modalRef = useRef(null);
  const [ContactUs, setContactUs] = useState({
    contactId: 0,
    contactType: "",
    contactDetail: "",
  });
  const [ContactList, setContactList] = useState([]);
  const [Title, setTitle] = useState("");
  const [GridList, setGridList] = useState([]);
  const [addressFlag, setaddressFlag] = useState(false);

  const ContactType = [
    {
      text: "Address",
      value: "Address",
    },
    {
      text: "Email",
      value: "Email",
    },
    {
      text: "Phone Number",
      value: "PhoneNumber",
    },
  ];

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const clearForm = () => {
    setContactUs({
      contactType: "",
      contactDetail: "",
    });
    setContactList([]);

    setEditVisible(false);
    setError({});

    const form = document.getElementById("event-form");
    if (form) {
      form.reset();
    }
    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = null;
    }
    $(".modal-backdrop.show").hide();
    $(".modal.custom-modal.fade").hide();
    const modal = new bootstrap.Modal(document.getElementById("add_ContactUs"));
    modal.hide();

    setrefreshflag(refreshflag + 1);
  };

  const OnAdd = async (e) => {
    e.preventDefault();
    let errDup = false;
    let errPhone = false;
    let errEmail = false;

    // for duplicate
    if (
      ContactUs.contactType == "PhoneNumber" ||
      ContactUs.contactType == "Email"
    ) {
      const isDuplicate =
        (GridList.length > 0 &&
          GridList.some(
            (item) =>
              item.contactDetails.trim().toLowerCase() ==
              ContactUs.contactDetail.trim().toLowerCase()
          )) ||
        (ContactList.length > 0 &&
          ContactList.some(
            (item) =>
              item.contactDetail.trim().toLowerCase() ===
              ContactUs.contactDetail.trim().toLowerCase()
          ));

      setError((prevError) => ({
        ...prevError,
        isPhoneDup:
          ContactUs.contactType == "PhoneNumber"
            ? isDuplicate
            : prevError.isPhoneDup,
        isEmailDup:
          ContactUs.contactType == "Email" ? isDuplicate : prevError.isEmailDup,
      }));

      errDup = isDuplicate;
    }
    //end for duplicate

    //for phone No
    if (
      ContactUs.contactType == "PhoneNumber" &&
      ContactUs.contactDetail != ""
    ) {
      let rawValue = ContactUs.contactDetail.replace(/\D/g, "");
      const isInvalidNumber =
        rawValue.length < 10 && ContactUs.contactDetail != "";

      setError((prevError) => ({
        ...prevError,
        invalidNo: isInvalidNumber,
      }));
      errPhone = isInvalidNumber;
    }
    // end for phone No

    //for email validation
    if (ContactUs.contactType == "Email" && ContactUs.contactDetail != "") {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      const isValidEmail = !emailPattern.test(ContactUs.contactDetail);

      setError((prevError) => ({
        ...prevError,
        ValidEmail: isValidEmail,
      }));
      errEmail = isValidEmail;
    }
    //end for email validation

    var err = ValidateForm(e);
    if (err) {
      setError(err);
    } else if (!errDup && !errPhone && !errEmail) {
      setError({ EmptyList: false });
      let temp = { ...ContactUs, guid: generateGuid() };

      setContactList([...ContactList, temp]);
      setContactUs((prev) => ({
        ...prev,
        contactType: "",
        contactDetail: "",
      }));
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (ContactList.length == 0) {
      setError({ EmptyList: true });
    } else {
      const formData = new FormData();
      ContactList.forEach((contact, index) => {
        formData.append(`contactModel[${index}].ContactId`, 0);
        formData.append(
          `contactModel[${index}].ContactType`,
          contact.contactType || ""
        );
        formData.append(
          `contactModel[${index}].ContactDetails`,
          contact.contactDetail || ""
        );
        formData.append(`contactModel[${index}].SavedBy`, sessionUser() || "");
      });

      try {
        await corepost("ContactUs/InsertUpdateContactUs", formData);
        fetchData();
        setrefreshflag(refreshflag + 1);
        clearForm(); // Properly reset and close the modal
      } catch (error) {
        console.error("Error during submission:", error);
      }
    }
  };

  const handleEditClick = async (e) => {
    setContactUs({
      contactId: e.contactId,
      contactType: e.contactType,
      contactDetail: e.contactDetails,
    });
    setTitle(e.contactType);
    const modal = new bootstrap.Modal(
      document.getElementById("update_contact")
    );
    modal.show();
  };

  const handleDeleteClick = async (e) => {
    const onDelete = () => {
      corefetch(
        `ContactUs/DeletedContactUs?addressID=${
          e.contactId
        }&deletedBy=${sessionUser()}`,
        true,
        false,
        true
      ).then(() => {
        fetchData();
        setrefreshflag(refreshflag + 1);
      });
    };
    confirmDelete(onDelete);
  };

  const handleContactAddDeleteClick = (e) => {
    const index = ContactList.findIndex((item) => item.guid == e.guid);

    if (index != -1) {
      const temp = ContactList.filter((_, i) => i !== index);
      setContactList(temp);
    }
  };

  const onUpdate = async (e) => {
    e.preventDefault();
    let errDup = false;
    let errPhone = false;
    let errEmail = false;

    // for duplicate
    const matchingItem = GridList.find(
      (item) => item.contactId == ContactUs.contactId
    );

    const contactDetailsValue = matchingItem
      ? matchingItem.contactDetails
      : null;

    if (contactDetailsValue != ContactUs.contactDetail) {
      if (
        ContactUs.contactType == "PhoneNumber" ||
        ContactUs.contactType == "Email"
      ) {
        const isDuplicate = GridList.some(
          (item) =>
            item.contactDetails.trim().toLowerCase() ==
            ContactUs.contactDetail.trim().toLowerCase()
        );

        setError((prevError) => ({
          ...prevError,
          isPhoneDup:
            ContactUs.contactType == "PhoneNumber"
              ? isDuplicate
              : prevError.isPhoneDup,
          isEmailDup:
            ContactUs.contactType == "Email"
              ? isDuplicate
              : prevError.isEmailDup,
        }));

        errDup = isDuplicate;
      }
    } else {
      setError((prevError) => ({
        ...prevError,
        isPhoneDup: false,
        isEmailDup: false,
      }));
    }
    //end for duplicate

    //for phone No
    if (
      ContactUs.contactType == "PhoneNumber" &&
      ContactUs.contactDetail != ""
    ) {
      let rawValue = ContactUs.contactDetail.replace(/\D/g, "");
      const isInvalidNumber =
        rawValue.length < 10 && ContactUs.contactDetail != "";

      setError((prevError) => ({
        ...prevError,
        invalidNo: isInvalidNumber,
      }));
      errPhone = isInvalidNumber;
    }
    // end for phone No

    //for email validation
    if (ContactUs.contactType == "Email" && ContactUs.contactDetail != "") {
      const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      const isValidEmail = !emailPattern.test(ContactUs.contactDetail);

      setError((prevError) => ({
        ...prevError,
        ValidEmail: isValidEmail,
      }));
      errEmail = isValidEmail;
    }
    var err = ValidateForm(e);

    if (err) {
      setError(err);
    } else if (!errDup && !errPhone && !errEmail) {
      try {
        const formData = new FormData();
        const contactList = [ContactUs];

        contactList.forEach((contact, index) => {
          formData.append(
            `contactModel[${index}].ContactId`,
            contact.contactId
          );
          formData.append(
            `contactModel[${index}].ContactType`,
            contact.contactType || ""
          );
          formData.append(
            `contactModel[${index}].ContactDetails`,
            contact.contactDetail || ""
          );
          formData.append(
            `contactModel[${index}].SavedBy`,
            sessionUser() || ""
          );
        });
        await corepost("ContactUs/InsertUpdateContactUs", formData);

        $("#update_contact").modal("hide");
        clearForm();
        fetchData();
        refreshflag(refreshflag + 1);
      } catch (error) {
        console.error(error);
      }
    }
  };
  const fetchData = async () => {
    try {
      const list = await corefetch("ContactUs/GetContactUsDetails");
      setGridList(list);
      if (list && list.length > 0) {
        let setAddress = list.some(
          (item) => item.contactType.toLowerCase() == "address"
        );
        setaddressFlag(setAddress);
      }
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, [refreshflag]);

  return (
    <>
      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-auto float-end ms-auto">
                <div className="d-flex justify-content-end mb-2">
                  <Button
                    name={"Add"}
                    dataBsToggle={"modal"}
                    dataBsTarget={"#add_ContactUs"}
                    dataBsDismiss={"modal"}
                  />
                </div>
              </div>
            </div>

            <div>
              <KendoGrid
                name={"subContact"}
                data={GridList}
                schema={{}}
                columns={[
                  {
                    field: "contactId",
                    filterable: false,
                    hidden: true,
                  },

                  {
                    field: "contactType",
                    title: "Contact Type",
                  },
                  {
                    field: "contactDetails",
                    title: "Contact Details",
                  },
                ]}
                paggable={true}
                showOptions={true}
                showEdit={true}
                showDelete={true}
                onEditClick={handleEditClick}
                onDeleteClick={handleDeleteClick}
                disableExportExcel={true}
                refreshWhen={refreshflag}
                height={"60vh"}
              />
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Add contactUs Add Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_ContactUs"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered " role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{editVisible ? "Edit" : "Add"}</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <form id="form-Contact" onSubmit={OnAdd}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        Contact Type <span className="text-danger">*</span>
                      </label>
                      <KendoDropdown
                        name="ContactType"
                        data={
                          ContactList.some(
                            (contact) => contact.contactType == "Address"
                          ) || addressFlag
                            ? ContactType.filter(
                                (item) => item.value !== "Address"
                              ) // Remove "Address" if either condition is true
                            : ContactType // Use the full list otherwise
                        }
                        value={ContactUs.contactType}
                        dataTextField="text"
                        dataValueField="value"
                        placeholder="Select Contact Type..."
                        required={true}
                        onValidate={onValidation}
                        onChange={(e) => {
                          setContactUs((prevEvents) => ({
                            ...prevEvents,
                            contactType: e,
                            contactDetail: "",
                          }));
                          setError((prevError) => ({
                            ...prevError,
                            Detail: false,
                            address: false,
                            phone: false,
                            email: false,
                            EmptyList: false,
                            isEmailDup: false,
                            isPhoneDup: false,
                          }));
                        }}
                      />

                      <CommonErrorMsg
                        text="Contact Type is required"
                        IsError={error.ContactType}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-10">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        Contact Detail <span className="text-danger">*</span>
                      </label>

                      {ContactUs.contactType == "Address" ? (
                        <textarea
                          className="form-control field"
                          name="address"
                          maxLength={200}
                          value={ContactUs.contactDetail || ""}
                          placeholder="Enter details"
                          rows="4"
                          data-required="true"
                          onChange={(e) => {
                            setContactUs((prev) => ({
                              ...prev,
                              contactDetail: e.target.value,
                            }));
                            onValidation("address", e.target.value);
                          }}
                        />
                      ) : ContactUs.contactType == "Email" ? (
                        <>
                          <input
                            type="text"
                            className="form-control field"
                            name="email"
                            value={ContactUs.contactDetail || ""}
                            placeholder="Enter email address"
                            data-required="true"
                            onChange={(e) => {
                              setContactUs((prev) => ({
                                ...prev,
                                contactDetail: e.target.value,
                              }));
                              onValidation("email", e.target.value);

                              const emailPattern =
                                /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                              if (
                                !emailPattern.test(e.target.value) &&
                                e.target.value != ""
                              ) {
                                setError((prevError) => ({
                                  ...prevError,
                                  ValidEmail: true,
                                }));
                                setError((prevError) => ({
                                  ...prevError,
                                  isEmailDup: false,
                                }));
                              } else {
                                setError((prevError) => ({
                                  ...prevError,
                                  ValidEmail: false,
                                }));
                                const isDuplicate =
                                  (GridList.length > 0 &&
                                    GridList.some(
                                      (item) =>
                                        item.contactDetails
                                          .trim()
                                          .toLowerCase() ==
                                        e.target.value.trim().toLowerCase()
                                    )) ||
                                  (ContactList.length > 0 &&
                                    ContactList.some(
                                      (item) =>
                                        item.contactDetail
                                          .trim()
                                          .toLowerCase() ===
                                        e.target.value.trim().toLowerCase()
                                    ));

                                setError((prevError) => ({
                                  ...prevError,
                                  isEmailDup: isDuplicate,
                                }));
                              }
                            }}
                          />

                          {error.ValidEmail && (
                            <ErrorMsg text="Please provide a valid email address" />
                          )}
                        </>
                      ) : ContactUs.contactType == "PhoneNumber" ? (
                        <input
                          type="text"
                          className="form-control field"
                          name="phone"
                          value={ContactUs.contactDetail || ""}
                          placeholder="Enter phone number"
                          data-required="true"
                          maxLength={14}
                          onChange={(e) => {
                            setError((prevError) => ({
                              ...prevError,
                              phone: false,
                            }));
                            let rawValue = e.target.value.replace(/\D/g, "");

                            if (rawValue.length > 10)
                              rawValue = rawValue.substring(0, 10);

                            let formattedValue = "";
                            if (rawValue.length > 3) {
                              formattedValue = `(${rawValue.substring(
                                0,
                                3
                              )}) ${rawValue.substring(3, 6)}${
                                rawValue.length > 6
                                  ? "-" + rawValue.substring(6)
                                  : ""
                              }`;
                            } else if (rawValue.length > 0) {
                              formattedValue = `(${rawValue}`;
                            }

                            setContactUs((prev) => ({
                              ...prev,
                              contactDetail: formattedValue,
                            }));
                            if (rawValue.length == 0) {
                              onValidation("Detail", "Details are required");
                            }
                            if (rawValue.length < 10 && rawValue != "") {
                              setError((prevError) => ({
                                ...prevError,
                                invalidNo: true,
                              }));
                            } else {
                              onValidation("phone", rawValue);
                              setError((prevError) => ({
                                ...prevError,
                                invalidNo: false,
                              }));
                            }
                            const isDuplicate =
                              (GridList.length > 0 &&
                                GridList.some(
                                  (item) =>
                                    item.contactDetails.trim().toLowerCase() ===
                                    formattedValue.trim().toLowerCase()
                                )) ||
                              (ContactList.length > 0 &&
                                ContactList.some(
                                  (item) =>
                                    item.contactDetail.trim().toLowerCase() ===
                                    e.target.value.trim().toLowerCase()
                                ));

                            setError((prevError) => ({
                              ...prevError,
                              isPhoneDup: isDuplicate,
                            }));
                          }}
                          onKeyDown={(e) => {
                            const rawValue = ContactUs.contactDetail?.replace(
                              /\D/g,
                              ""
                            );
                            if (
                              rawValue.length >= 10 &&
                              ![
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                              ].includes(e.key)
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      ) : (
                        <input
                          className="form-control field"
                          name="Detail"
                          value={""}
                          placeholder="Enter details"
                          data-required="true"
                        />
                      )}

                      {error.Detail && <ErrorMsg text="Detail is required" />}
                      {error.address && <ErrorMsg text="Address is required" />}
                      {error.email && <ErrorMsg text="Email Id is required" />}
                      {error.phone && <ErrorMsg text="Phone No is required" />}
                      {error.isPhoneDup && (
                        <ErrorMsg text="Phone No is already exist" />
                      )}
                      {error.isEmailDup && (
                        <ErrorMsg text="Email is already exist" />
                      )}
                      {error.invalidNo && (
                        <ErrorMsg text="Provide valid Phone No" />
                      )}

                      {error.EmptyList && (
                        <ErrorMsg text="Atleast add one contact" />
                      )}
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="input-block mb-3">
                      <button
                        type="submit"
                        className="btn btn-primary mt-4"
                        title="Add Contact Details"
                      >
                        <i className="las la-plus-circle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
              <form id="subgrid-form" onSubmit={onSubmit}>
                <span className="k-form-error k-invalid-msg">
                  (Note: Only the items added to the grid will be saved.)
                </span>
                <KendoGrid
                  name={"ContactSubGrid"}
                  disableToolbar={true}
                  data={ContactList}
                  columns={[
                    {
                      field: "guid",
                      hidden: true,
                    },
                    {
                      field: "contactType",
                      title: "Contact Type",
                    },
                    {
                      field: "contactDetail",
                      title: "Contact Details",
                    },
                  ]}
                  paggable={true}
                  showOptions={true}
                  showDelete={true}
                  showEdit={false}
                  scrollable={true}
                  onDeleteClick={(e) => handleContactAddDeleteClick(e)}
                  refreshWhen={ContactList.length}
                  height={"40vh"}
                />

                <div className="text-end btn-mt">
                  <Button
                    name={"Cancel"}
                    isCancelButton={true}
                    dataBsDismiss={"modal"}
                    onClick={clearForm}
                  />
                  <Button name={editVisible ? "Update" : "Save"} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Update Contact Modal --> */}
      <div
        className="modal custom-modal fade"
        id="update_contact"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit {Title}</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={clearForm}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="subUpdateContact-form" onSubmit={onUpdate}>
                <input
                  type="hidden"
                  name="contactId"
                  value={ContactUs.contactId}
                />
                <div className="row">
                  <div className="col-md-12">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        Contact Type <span className="text-danger">*</span>
                      </label>
                      <KendoDropdown
                        name="ConType"
                        data={
                          (ContactList.some(
                            (contact) => contact.contactType == "Address"
                          ) &&
                            ContactUs.contactType == "Address") ||
                          (addressFlag && ContactUs.contactType !== "Address")
                            ? ContactType.filter(
                                (item) => item.value !== "Address"
                              )
                            : ContactType
                        }
                        value={ContactUs.contactType}
                        dataTextField="text"
                        dataValueField="value"
                        placeholder="Select Contact Type..."
                        required={true}
                        onValidate={onValidation}
                        onChange={(e) => {
                          setContactUs((prevEvents) => ({
                            ...prevEvents,
                            contactType: e,
                            contactDetail: "",
                          }));
                          setError((prevError) => ({
                            ...prevError,
                            Detail: false,
                            address: false,
                            phone: false,
                            email: false,
                            EmptyList: false,
                            isEmailDup: false,
                            isPhoneDup: false,
                            ValidEmail: false,
                            invalidNo: false,
                          }));
                        }}
                      />
                      {/* {error.ContactType && (
                        <ErrorMsg text="Contact Type is required" />
                      )} */}
                      {error.ConType && (
                        <ErrorMsg text="Contact Type is required" />
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-10">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        Detail <span className="text-danger">*</span>
                      </label>
                      {ContactUs.contactType == "Address" ? (
                        <textarea
                          className="form-control field"
                          name="address"
                          maxLength={200}
                          value={ContactUs.contactDetail || ""}
                          placeholder="Enter details"
                          rows="4"
                          data-required="true"
                          onChange={(e) => {
                            setContactUs((prev) => ({
                              ...prev,
                              contactDetail: e.target.value,
                            }));
                            onValidation("address", e.target.value);
                          }}
                        />
                      ) : ContactUs.contactType == "Email" ? (
                        <>
                          <input
                            type="email"
                            className="form-control field"
                            name="email"
                            value={ContactUs.contactDetail || ""}
                            placeholder="Enter email address"
                            data-required="true"
                            onChange={(e) => {
                              setContactUs((prev) => ({
                                ...prev,
                                contactDetail: e.target.value,
                              }));
                              onValidation("email", e.target.value);

                              const emailPattern =
                                /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

                              if (
                                !emailPattern.test(e.target.value) &&
                                e.target.value != ""
                              ) {
                                setError((prevError) => ({
                                  ...prevError,
                                  ValidEmail: true,
                                }));
                              } else {
                                setError((prevError) => ({
                                  ...prevError,
                                  ValidEmail: false,
                                }));
                              }

                              const matchingItem = GridList.find(
                                (item) => item.contactId == ContactUs.contactId
                              );

                              const contactDetailsValue = matchingItem
                                ? matchingItem.contactDetails
                                : null;

                              if (contactDetailsValue != e.target.value) {
                                const isDuplicate = GridList.some(
                                  (item) =>
                                    item.contactDetails.trim().toLowerCase() ==
                                    e.target.value.trim().toLowerCase()
                                );

                                setError((prevError) => ({
                                  ...prevError,
                                  isEmailDup: isDuplicate,
                                }));
                              } else {
                                setError((prevError) => ({
                                  ...prevError,
                                  isEmailDup: false,
                                }));
                              }
                            }}
                          />
                          {error.ValidEmail && (
                            <ErrorMsg text="Please provide a valid email address" />
                          )}
                          {error.isEmailDup && (
                            <ErrorMsg text="Email is already exist" />
                          )}
                        </>
                      ) : ContactUs.contactType == "PhoneNumber" ? (
                        <input
                          type="text"
                          className="form-control field"
                          name="phone"
                          value={ContactUs.contactDetail || ""}
                          placeholder="Enter phone number"
                          data-required="true"
                          maxLength={14}
                          onChange={(e) => {
                            let rawValue = e.target.value.replace(/\D/g, "");
                            let formattedValue = "";

                            if (rawValue.length > 10)
                              rawValue = rawValue.substring(0, 10);

                            if (rawValue.length > 3) {
                              formattedValue = `(${rawValue.substring(
                                0,
                                3
                              )}) ${rawValue.substring(3, 6)}${
                                rawValue.length > 6
                                  ? "-" + rawValue.substring(6)
                                  : ""
                              }`;
                            } else if (rawValue.length > 0) {
                              formattedValue = `(${rawValue}`;
                            }

                            setContactUs((prev) => ({
                              ...prev,
                              contactDetail: formattedValue,
                            }));

                            if (rawValue.length < 10 && rawValue != "") {
                              setError((prevError) => ({
                                ...prevError,
                                invalidNo: true,
                              }));
                            } else {
                              setError((prevError) => ({
                                ...prevError,
                                invalidNo: false,
                              }));
                            }
                            onValidation("phone", rawValue);

                            const matchingItem = GridList.find(
                              (item) => item.contactId == ContactUs.contactId
                            );

                            const contactDetailsValue = matchingItem
                              ? matchingItem.contactDetails
                              : null;

                            if (contactDetailsValue != formattedValue) {
                              const isDuplicate = GridList.some(
                                (item) =>
                                  item.contactDetails.trim().toLowerCase() ==
                                  formattedValue.trim().toLowerCase()
                              );

                              setError((prevError) => ({
                                ...prevError,
                                isPhoneDup: isDuplicate,
                              }));
                            } else {
                              setError((prevError) => ({
                                ...prevError,
                                isPhoneDup: false,
                              }));
                            }
                          }}
                          onKeyDown={(e) => {
                            const rawValue = ContactUs.contactDetail?.replace(
                              /\D/g,
                              ""
                            );
                            if (
                              rawValue.length >= 10 &&
                              ![
                                "Backspace",
                                "Delete",
                                "ArrowLeft",
                                "ArrowRight",
                              ].includes(e.key)
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      ) : (
                        <input
                          className="form-control field"
                          name="Detail"
                          value={""}
                          placeholder="Enter details"
                          data-required="true"
                        />
                      )}
                      {error.Detail && <ErrorMsg text="Detail is required" />}
                      {error.address && <ErrorMsg text="Address is required" />}
                      {error.email && <ErrorMsg text="Email Id is required" />}
                      {error.phone && <ErrorMsg text="Phone No is required" />}
                      {error.isPhoneDup && (
                        <ErrorMsg text="Phone No is already exist" />
                      )}
                      {error.invalidNo && (
                        <ErrorMsg text="Provide valid Phone No" />
                      )}
                      {error.EmptyList && (
                        <ErrorMsg text="Atleast add one contact" />
                      )}
                    </div>
                  </div>
                </div>
                <div className="text-end btn-mt">
                  <Button
                    name={"Cancel"}
                    isCancelButton={true}
                    id="contactus-cancel"
                    dataBsDismiss={"modal"}
                    onClick={() => {
                      clearForm();
                    }}
                  />
                  <Button name={"Update"} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Update Update Contact Modal --> */}
    </>
  );
};
